import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";


async function getLocations({page = "page=1",term = ""}) {
  const res = await getFetch(`/Locations?term=${term}&${page}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeLocation(form) {
  if (form.get("name") === "") {
    return {
      status: "error",
      message: "عنوان الزامی است!",
    };
  }

  const res = await postFetchWithToken("/Locations/store", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: "محل استقرار با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function deleteLocation(id) {
  const res = await postFetchWithBody(`/Locations/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { storeLocation , getLocations,deleteLocation};
